/* eslint-disable no-undef */

import React                  from 'react'
import { withRouter }         from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'

import GoogleLogin from 'react-google-login'
import queryString from 'query-string'

import { Form, Input, Button, Row, Col, message, Tooltip } from 'antd'

import {LOGIN_SUCCESS, register} from '../../../actions/auth'
import FileCatalystLogo from '../../../assets/logo/FileCatalyst.png'
import GoogleLogo       from '../../../assets/logo/google-logo.png'

import CloudFlyerAPI from "../../../api/CloudFlyerAPI"
import {receiveData} from "../../../api/http"

import './styles.scss'

class Register extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      busy        : false,
      referrer_id : null,
      invite_token: null
    }
  }

  componentDidMount() {
    const { referrer_id, invite_token } = queryString.parse(this.props.location.search)
    if (invite_token) {
      try {
        const decodedStr = atob(invite_token)
        const user = decodedStr.split('//')
        // format: email//firstname//lastname//roleid//orgid
        if (user.length === 5) {
          const [email, first_name, last_name] = user
          this.props.form.setFieldsValue({
            email,
            first_name,
            last_name
          })
          this.setState({
            invite_token
          })
        }
      } catch (e) {
        console.log('base64 decoding for invite_token failed with error \n', e)
      }
    }
    this.setState({
      loading: false,
      referrer_id: (referrer_id ? referrer_id : undefined)
    })
  }

  handleSubmit (e) {
    e.preventDefault()

    const { email, password, confirmPassword, last_name, first_name, company, promo_code } = this.props.form.getFieldsValue()

    if (email === undefined || password === undefined || confirmPassword === undefined) {
      this.setState({ busy: false })
      message.error("Incorrect user or password or confirm password");
    } else if (password !== confirmPassword) {
      this.setState({ busy: false })
      message.error("please input correct password and confirm password");
    } else {
      const { invite_token, referrer_id } = this.state
      let user = {
        email: email.toLocaleLowerCase(),
        password,
        last_name,
        first_name,
        company,
        referrer_id,
        promo_code
      }
      if (invite_token) {
        user = { ...user, invite_token }
      }
      this.props.register(user)
    }
  }

  componentWillReceiveProps (props) {
    if(props.user) {
      if(this.state.invite_token){
        return this.props.history.replace('/login')
      }
      this.props.history.replace('/postSignup')
    }
  }

  on_google_login = response => {
    let $this = this
    if(!response || !response.tokenObj){
      return
    }

    const {invite_token, referrer_id} = this.state

    $this.setState({auth_loading:true})
    CloudFlyerAPI.user_account
      .loginOAuth({
        service : "Google",
        token   : response.tokenObj.id_token,
        email   : response.profileObj.email,
        invite_token, referrer_id
      })
      .then(res=>{
        $this.props.dispatch(receiveData(LOGIN_SUCCESS, ((res||{}).data||{})))
        $this.setState({auth_loading:false})
        $this.props.history.replace('/')
      })
      .catch(err=>{
        $this.setState({auth_loading:false})
        console.error(err)
      })
  }

  toLogin () {
    let path = this.state.referrer_id !== undefined ? ('/?referrer_id=' + this.state.referrer_id) : ''
    this.props.history.replace('/login' + path);
  }

  render () {
    const { getFieldDecorator } = this.props.form
    const { referrer_id, invite_token } = this.state

    let google_client_id = window.GOOGLE_CLIENT_ID
    console.log(google_client_id)

    return (
      <Row className="register-row" type="flex" justify="space-around" align="middle">
        <Col span="12">
          <Form layout="horizontal" onSubmit={this.handleSubmit.bind(this)} className="register-form">
            <Row>
              <Col span="12">
                <h2 className="logo"><span>logo</span></h2>
              </Col>
              <Col span="12">
                <Button className="btn-login" size="large" htmlType='button' onClick={this.toLogin.bind(this)} >Have an account? Login!</Button>
              </Col>
            </Row>
            <Row type="flex" justify="space-around" align="middle">
              <Col span="12">
                <p className="register-txt">
                  This is the start of something great!
                </p>
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={24} align="middle">
              <Col span="10">
                <Form.Item>
                  {getFieldDecorator('first_name')(
                    <Input className="register-input" placeholder='First name' />
                  )}
                </Form.Item>
              </Col>
              <Col span="10">
                <Form.Item>
                  {getFieldDecorator('last_name')(
                    <Input className="register-input" placeholder='Last name' />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={24} align="middle">
              <Col span="10">
                <Form.Item>
                  {getFieldDecorator('email')(
                    <Input className="register-input" placeholder='Your email' disabled={!!invite_token}/>
                  )}
                </Form.Item>
              </Col>
              <Col span="10">
                <Form.Item>
                  {getFieldDecorator('company')(
                    <Input className="register-input" placeholder='Your company (not mandatory)' />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="center" gutter={24} align="middle">
              <Col span="10">
                <Tooltip placement="rightTop" title="Password requirements were not met. Password requirements: at least 8 characters, a lowercase letter, an uppercase letter, a number.">
                <a href="#">
                <Form.Item>
                  {getFieldDecorator('password')(
                    <Input type='password' className="register-input" placeholder='Your password' />
                  )}
                </Form.Item>
                </a>
                </Tooltip>
              </Col>
              <Col span="10">
                <Form.Item>
                  {getFieldDecorator('confirmPassword')(
                    <Input type='password' className="register-input" placeholder='Confirm password' />
                  )}
                </Form.Item>
              </Col>
            </Row>
            <Row type="flex" justify="space-around" align="middle">
              <Col span="20">
                <Form.Item>
                  {getFieldDecorator('promo_code')(
                    <Input className="register-promo-input" placeholder='Have a promo code?' />
                  )}
                </Form.Item>
              </Col>
            </Row>

            <Row type="flex" justify="space-around" align="middle">
              <Col span="20">
                { referrer_id ? <img className={'file_catalyst_logo'} src={FileCatalystLogo}/> : null }
              </Col>
            </Row>

            <Row type="flex" justify="space-around" align="middle">
              <Button className="btn-register" type='primary' size="large" loading={this.state.busy} htmlType='submit'>Create my account</Button>

              <GoogleLogin className="btn-google-login"
                           clientId={GOOGLE_CLIENT_ID}
                           buttonText="Login"
                           onSuccess={this.on_google_login.bind(this)}
                           onFailure={this.on_google_login.bind(this)}>
                <img src={GoogleLogo}/>
                <span>Signup with Google Account</span>
              </GoogleLogin>
            </Row>
          </Form>
        </Col>
      </Row>
    )
  }
}

Register = Form.create()(Register);

function mapStateToProps(state) {
  const {auth} = state
  if (auth) {
    return {user: auth.user, busy: auth.busy, error: auth.error}
  }
  return {user: null, busy: null, error: null}
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({
    register,
    dispatch
  }, dispatch)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Register))

